module.exports = __webpack_public_path__ + "img/reset_button.8d0a89dd.svg";